var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChooseLawyerbg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 501,
    height: 434,
    viewBox: "0 0 501 434",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.771 0.465717C285.669 6.6224 295.488 82.9962 337.687 118.616C388.54 161.54 480.609 161.05 497.3 225.44C514.72 292.641 467.984 365.252 412.426 406.938C361.831 444.9 293.371 434.614 230.771 425.418C179.366 417.867 134.936 394.422 95.6849 360.409C52.35 322.856 -0.240856 282.753 0.000829947 225.44C0.242133 168.217 55.8262 131.566 96.8185 91.6031C137.013 52.4184 174.964 -5.79295 230.771 0.465717Z",
    fill: "#FDF8F8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseLawyerbg);
export default __webpack_public_path__ + "static/media/chooseLawyerbg.5c448bf572d143cadab8aa1b875bf606.svg";
export { ForwardRef as ReactComponent };